import React from 'react';
import { FaStar } from 'react-icons/fa';

export default function PostRating(props) {
  const { rating, totalUsers, color = '#FFC107', url, hideNumbers, size = 20 } = props;
  const MAX_STARS = 5;

  const handleClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const stars = Array.from({ length: MAX_STARS }, (_, index) => {
    const fillPercent = Math.min(Math.max(rating - index, 0), 1) * 100;

    return (
      <idk-div key={index} class="zid-relative">
        <FaStar className="zid-text-gray-300" fontSize={size} />
        <idk-div class="zid-absolute zid-top-0 zid-left-0 zid-overflow-hidden" style={{ width: `${fillPercent}%` }}>
          <FaStar style={{ color: color }} fontSize={size} />
        </idk-div>
      </idk-div>
    );
  });

  return (
    <idk-div onClick={handleClick} class="zid-flex zid-items-center zid-space-x-2 zid-cursor-pointer">
      <idk-div class="zid-flex">{stars}</idk-div>
      {hideNumbers !== true && (
        <>
          <idk-span class="zid-text-sm zid-font-medium zid-text-black">{rating.toFixed(1)}</idk-span>
          <idk-span class="zid-text-sm zid-text-gray-500">({totalUsers})</idk-span>
        </>
      )}
    </idk-div>
  );
}
